<aside [class]="'icon icon--' + type">
  <svg *ngIf="type == 'nav_arrow'" version="1.1" viewBox="0 0 10 19" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-160 -96)" fill="currentColor" fill-rule="nonzero">
        <g transform="translate(0 72)">
          <g transform="translate(160 24)">
            <g transform="translate(0 .4)">
              <path
                transform="translate(5 9) rotate(90) translate(-5 -9)"
                d="m5 11.586l-7.2929-7.2929c-0.39052-0.39052-1.0237-0.39052-1.4142 0s-0.39052 1.0237 0 1.4142l8 8c0.39052 0.39052 1.0237 0.39052 1.4142 0l8-8c0.39052-0.39052 0.39052-1.0237 0-1.4142s-1.0237-0.39052-1.4142 0l-7.2929 7.2929z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <svg *ngIf="type == 'solid_arrow'" version="1.1" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-1272 -320)">
        <g
          transform="translate(160 306)"
          fill="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        >
          <g transform="translate(1112 14)">
            <g transform="translate(0)">
              <polyline
                transform="translate(4 7) rotate(-90) translate(-4 -7)"
                points="9.6 4.3333 4 9.6667 -1.6 4.3333"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <svg *ngIf="type == 'expand'" version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-248 -715)" fill="currentColor" fill-rule="nonzero">
        <g transform="translate(45 626)">
          <g transform="translate(27 87)">
            <g transform="translate(176 2)">
              <path
                d="m14.559 5.0956c0 0.40203 0.32591 0.72794 0.72794 0.72794s0.72794-0.32591 0.72794-0.72794v-4.3676c0-0.40203-0.32591-0.72794-0.72794-0.72794h-4.3676c-0.40203 0-0.72794 0.32591-0.72794 0.72794 0 0.40203 0.32591 0.72794 0.72794 0.72794h3.6397v3.6397z"
              />
              <path
                d="m14.772 0.21321l-9.7059 9.7059c-0.28428 0.28428-0.28428 0.74519 0 1.0295s0.74519 0.28428 1.0295 0l9.7059-9.7059c0.28428-0.28428 0.28428-0.74519 0-1.0295-0.28428-0.28428-0.74519-0.28428-1.0295 0z"
              />
              <path
                d="m7.5221 2.9118h-5.8235c-0.93807 0-1.6985 0.7607-1.6985 1.6991v9.709c1.8858e-16 0.93838 0.76046 1.6991 1.6985 1.6991h9.7059c0.93807 0 1.6985-0.7607 1.6985-1.6991v-5.8254c0-0.40216-0.32591-0.72818-0.72794-0.72818s-0.72794 0.32602-0.72794 0.72818v5.8254c0 0.13405-0.10864 0.24273-0.24265 0.24273h-9.7059c-0.13401 0-0.24265-0.10867-0.24265-0.24273v-9.709c0-0.13405 0.10864-0.24273 0.24265-0.24273h5.8235c0.40203 0 0.72794-0.32602 0.72794-0.72818s-0.32591-0.72818-0.72794-0.72818z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <svg *ngIf="type == 'confirm'" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path d="M-997-564H443V809H-997z" />
      <g stroke-width="1.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
        <path d="M15.869 8.854l-6.576 6.138L7.1 12.8" />
        <path
          d="M22.006 11.923c0 5.57-4.515 10.083-10.083 10.083-5.57 0-10.083-4.513-10.083-10.083S6.353 1.84 11.923 1.84c5.568 0 10.083 4.514 10.083 10.083z"
        />
      </g>
    </g>
  </svg>

  <svg
    *ngIf="type === 'search'"
    width="16px"
    height="16px"
    version="1.1"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd" stroke-linejoin="round">
      <g transform="translate(-819 -424)" stroke="currentColor">
        <g transform="translate(819 424)">
          <g transform="translate(1 1)">
            <g stroke-width="1.5">
              <path
                d="m11.688 5.8442c0 3.2285-2.6172 5.8442-5.8442 5.8442-3.227 0-5.8442-2.6157-5.8442-5.8442 0-3.2285 2.6172-5.8442 5.8442-5.8442 3.227 0 5.8442 2.6157 5.8442 5.8442z"
              />
              <path d="m10.519 10.519l3.4578 3.4578" stroke-linecap="round" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

  <svg
    *ngIf="type === 'clear'"
    width="16px"
    height="16px"
    version="1.1"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-1202 -354)">
        <g transform="translate(1202 354)">
          <circle cx="8" cy="8" r="7.5" stroke="currentColor" />
          <rect
            transform="translate(8 8) rotate(45) translate(-8 -8)"
            x="3"
            y="7.5"
            width="10"
            height="1"
            rx=".5"
            fill="currentColor"
            fill-rule="evenodd"
          />
          <rect
            transform="translate(8 8) rotate(-45) translate(-8 -8)"
            x="3"
            y="7.5"
            width="10"
            height="1"
            rx=".5"
            fill="currentColor"
            fill-rule="evenodd"
          />
        </g>
      </g>
    </g>
  </svg>

  <svg
    *ngIf="type === 'down'"
    width="10px"
    height="6px"
    version="1.1"
    viewBox="0 0 10 6"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <g transform="translate(-648 -427)" stroke="currentColor" stroke-width="2">
        <g transform="translate(648 427)">
          <polyline points="9 1 5 5 1 1" />
        </g>
      </g>
    </g>
  </svg>

  <svg
    *ngIf="type === 'up'"
    width="10px"
    height="6px"
    version="1.1"
    viewBox="0 0 10 6"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <g transform="translate(-690 -427)" stroke="currentColor" stroke-width="2">
        <g transform="translate(690 427)">
          <polyline transform="translate(5 3) scale(1 -1) translate(-5 -3)" points="9 1 5 5 1 1" />
        </g>
      </g>
    </g>
  </svg>

  <svg
    *ngIf="type === 'lock'"
    width="12"
    height="15"
    version="1.1"
    viewBox="0 0 12 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-958 -250)" fill="currentColor" fill-rule="nonzero">
        <g transform="translate(714 42)">
          <g transform="translate(244 208)">
            <g transform="translate(0)">
              <path
                d="m7.2667 9.7222c0 0.72851-0.5673 1.3194-1.2667 1.3194s-1.2667-0.59093-1.2667-1.3194c0-0.72851 0.5673-1.3194 1.2667-1.3194s1.2667 0.59093 1.2667 1.3194zm-1.2 0c0-0.038155-0.030038-0.069444-0.066667-0.069444s-0.066667 0.031289-0.066667 0.069444c0 0.038155 0.030038 0.069444 0.066667 0.069444s0.066667-0.031289 0.066667-0.069444z"
              />
              <path
                d="m11.933 14.333c0 0.34518-0.26863 0.625-0.6 0.625h-10.667c-0.33137 0-0.6-0.27982-0.6-0.625v-8.3333c0-0.34518 0.26863-0.625 0.6-0.625h10.667c0.33137 0 0.6 0.27982 0.6 0.625v8.3333zm-1.2-0.625v-7.0833h-9.4667v7.0833h9.4667z"
              />
              <path
                d="m6.6 11.806v-1.3889c0-0.34518-0.26863-0.625-0.6-0.625s-0.6 0.27982-0.6 0.625v1.3889c0 0.34518 0.26863 0.625 0.6 0.625s0.6-0.27982 0.6-0.625z"
              />
              <path
                d="m2.6 6v-1.1389c0-1.9562 1.522-3.5417 3.4-3.5417 1.8771 0 3.4 1.586 3.4 3.5417v1.1389c0 0.34518 0.26863 0.625 0.6 0.625 0.33137 0 0.6-0.27982 0.6-0.625v-1.1389c0-2.6461-2.0602-4.7917-4.6-4.7917-2.5407 0-4.6 2.1451-4.6 4.7917v1.1389c0 0.34518 0.26863 0.625 0.6 0.625s0.6-0.27982 0.6-0.625z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

  <svg *ngIf="type === 'kebab'" width="40" height="40" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <g transform="rotate(90 6.5 16)" fill="currentColor">
        <circle cx="2.5" cy="2.5" r="2.5" />
        <circle cx="10.5" cy="2.5" r="2.5" />
        <circle cx="18.5" cy="2.5" r="2.5" />
      </g>
      <circle stroke="transparent" fill-opacity="0" stroke-width="2" cx="20" cy="20" r="19" />
    </g>
  </svg>

  <svg
    *ngIf="type === 'download'"
    width="13"
    height="14"
    version="1.1"
    viewBox="0 0 13 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd" stroke-linecap="round">
      <g transform="translate(-1196 -214)" stroke="currentColor" stroke-width="1.5">
        <g transform="translate(1197 211)">
          <g transform="translate(0 4)">
            <path d="m5.516 8.2857v-8" stroke-linejoin="round" />
            <polyline points="7.8018 6 5.516 8.2857 3.2303 6" stroke-linejoin="round" />
            <polyline points="-1.1369e-13 9.1296 -1.1369e-13 12.007 10.948 12.007 10.948 9.1296" />
          </g>
        </g>
      </g>
    </g>
  </svg>

  <svg *ngIf="type === 'exclamation'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
    <g fill="currentColor" fill-rule="nonzero">
      <path
        d="M24.5 26.552V12.448c0-.8-.672-1.448-1.5-1.448s-1.5.648-1.5 1.448v14.104c0 .8.672 1.448 1.5 1.448s1.5-.648 1.5-1.448zM25.5 33.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm-2.949 0a.448.448 0 1 0 .897 0 .448.448 0 0 0-.897 0z"
      />
      <path
        d="M23 45.996C10.3 46.216.223 36.1.003 23.4-.218 10.703 10.3.223 23 .004c12.7-.222 22.777 9.899 22.997 22.595.221 12.7-10.294 23.176-22.997 23.397zm19.685-23.322c-.18-10.416-9.39-19.538-19.61-19.36-10.418.18-19.938 9.793-19.76 20.01.18 10.419 9.389 19.538 19.61 19.361 10.421-.181 19.938-9.79 19.76-20.011z"
      />
    </g>
  </svg>

  <svg
    *ngIf="type === 'close'"
    version="1.1"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-396 -878)" fill="currentColor">
        <g transform="translate(156 645)">
          <g transform="translate(240 233)">
            <rect
              transform="translate(12 12) rotate(45) translate(-12 -12)"
              x="-3"
              y="10.5"
              width="30"
              height="3"
              rx="1.5"
            />
            <rect
              transform="translate(12 12) rotate(-45) translate(-12 -12)"
              x="-3"
              y="10.5"
              width="30"
              height="3"
              rx="1.5"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>

  <svg
    *ngIf="type === 'question-mark'"
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        stroke="currentColor"
        stroke-linejoin="round"
        d="M8.001 15.344A7.384 7.384 0 0 1 .617 7.959a7.385 7.385 0 1 1 7.385 7.385z"
      />
      <path fill="currentColor" d="M7.271 11.981a.73.73 0 1 0 1.459.002.73.73 0 0 0-1.459-.002z" />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M5.813 5.779A2.19 2.19 0 1 1 8 7.967v2.19"
      />
    </g>
  </svg>

  <svg *ngIf="type === 'left-arrow'" width="17" height="11" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor" fill-rule="nonzero">
      <path d="M15.5 4.75h-14a.75.75 0 0 0 0 1.5h14a.75.75 0 1 0 0-1.5z" />
      <path
        d="M2.56 5.5l3.47-3.47A.75.75 0 0 0 4.97.97l-4 4a.75.75 0 0 0 0 1.06l4 4a.75.75 0 0 0 1.06-1.06L2.56 5.5z"
      />
    </g>
  </svg>
  <svg *ngIf="type === 'kebab-outline'" width="40" height="40" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <g transform="rotate(90 6.5 16)" fill="currentColor">
        <circle cx="2.5" cy="2.5" r="2.5" />
        <circle cx="10.5" cy="2.5" r="2.5" />
        <circle cx="18.5" cy="2.5" r="2.5" />
      </g>
      <circle stroke="currentColor" stroke-width="2" cx="20" cy="20" r="19" />
    </g>
  </svg>

  <svg *ngIf="type === 'person'" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 8C9.433 8 11 6.433 11 4.5C11 2.567 9.433 1 7.5 1C5.567 1 4 2.567 4 4.5C4 6.433 5.567 8 7.5 8Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 15C2 11.6863 4.46243 9 7.5 9C10.5376 9 13 11.6863 13 15H2Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <svg *ngIf="type === 'people'" width="18" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.99984 9.99998C7.56464 9.99998 8.83317 8.73145 8.83317 7.16665C8.83317 5.60184 7.56464 4.33331 5.99984 4.33331C4.43503 4.33331 3.1665 5.60184 3.1665 7.16665C3.1665 8.73145 4.43503 9.99998 5.99984 9.99998Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.33325 15.6667C1.33325 13.0893 3.42259 11 5.99992 11C8.57725 11 10.6666 13.0893 10.6666 15.6667H1.33325Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.9999 15.6667H16.6665C16.6665 14.3869 15.9992 13.1998 14.906 12.5345C13.8128 11.8692 12.4518 11.822 11.3152 12.41"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9626 11C14.1592 11 15.1292 10.0299 15.1292 8.83329C15.1292 7.63668 14.1592 6.66663 12.9626 6.66663C11.7659 6.66663 10.7959 7.63668 10.7959 8.83329C10.7959 10.0299 11.7659 11 12.9626 11Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    *ngIf="type === 'external-link'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 1.75V5.5C14.25 5.91421 14.5858 6.25 15 6.25C15.4142 6.25 15.75 5.91421 15.75 5.5V1C15.75 0.585786 15.4142 0.25 15 0.25H10.5C10.0858 0.25 9.75 0.585786 9.75 1C9.75 1.41421 10.0858 1.75 10.5 1.75H14.25Z"
      fill="#0078B7"
    />
    <path
      d="M14.4688 0.46967L4.97016 9.96834C4.67726 10.2612 4.67726 10.7361 4.97016 11.029C5.26305 11.3219 5.73793 11.3219 6.03082 11.029L15.5295 1.53033C15.8224 1.23744 15.8224 0.762563 15.5295 0.46967C15.2366 0.176777 14.7617 0.176777 14.4688 0.46967Z"
      fill="#0078B7"
    />
    <path
      d="M8 2.25H2C1.0335 2.25 0.25 3.0335 0.25 4V14C0.25 14.9665 1.0335 15.75 2 15.75H12C12.9665 15.75 13.75 14.9665 13.75 14V8C13.75 7.58579 13.4142 7.25 13 7.25C12.5858 7.25 12.25 7.58579 12.25 8V14C12.25 14.1381 12.1381 14.25 12 14.25H2C1.86193 14.25 1.75 14.1381 1.75 14V4C1.75 3.86193 1.86193 3.75 2 3.75H8C8.41421 3.75 8.75 3.41421 8.75 3C8.75 2.58579 8.41421 2.25 8 2.25Z"
      fill="#0078B7"
    />
  </svg>
  <svg
    *ngIf="type === 'genesys-video-chat'"
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.2515 29C21.9329 29 16 34.9329 16 42.2515V53.7485C16 61.0671 21.9329 67 29.2515 67H53.0609C56.6562 67 59.9712 65.0583 61.7296 61.9224L66.1857 53.9759L75.2477 63.0379C76.924 64.7141 79.7901 63.5269 79.7901 61.1563V47.7901V34.8254C79.7901 32.3066 76.7448 31.0453 74.9638 32.8263L66.4384 41.3517L64.4412 38.087L61.7895 33.7523C59.9836 30.8002 56.7721 29 53.3114 29H29.2515ZM24 38.6564C24 37.7416 24.7416 37 25.6564 37H38.908C39.8228 37 40.5644 37.7416 40.5644 38.6564C40.5644 39.5713 39.8228 40.3129 38.908 40.3129H25.6564C24.7416 40.3129 24 39.5713 24 38.6564ZM26.5 48C27.8807 48 29 46.8807 29 45.5C29 44.1193 27.8807 43 26.5 43C25.1193 43 24 44.1193 24 45.5C24 46.8807 25.1193 48 26.5 48Z"
      fill="white"
    />
  </svg>
  <svg
    *ngIf="type === 'genesys-cobrowse'"
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.1062 26.9735C26.2715 26.9735 23.9735 29.2714 23.9735 32.1061V36.2123V54.6898C23.9735 57.5245 26.2715 59.8225 29.1062 59.8225H30.1327V62.8939C30.1327 65.7286 32.4307 68.0265 35.2654 68.0265H68.1144C70.9491 68.0265 73.247 65.7286 73.247 62.8939V44.4294C73.247 44.4278 73.247 44.4261 73.247 44.4245C73.247 44.4229 73.247 44.4212 73.247 44.4196V40.3102C73.247 37.4755 70.9491 35.1775 68.1144 35.1775H67.0879V32.1061C67.0879 29.2714 64.7899 26.9735 61.9552 26.9735H29.1062ZM67.0879 37.2306V43.398H71.194V40.3102C71.194 38.6094 69.8152 37.2306 68.1144 37.2306H67.0879ZM71.194 45.451H67.0879V54.6898C67.0879 57.5245 64.7899 59.8225 61.9552 59.8225H32.1858V62.8939C32.1858 64.5947 33.5645 65.9735 35.2654 65.9735H68.1144C69.8152 65.9735 71.194 64.5947 71.194 62.8939V45.451ZM31.2897 57.7694H61.9552C63.656 57.7694 65.0348 56.3906 65.0348 54.6898L65.0348 44.4245L65.0348 37.2388H26.0266V54.6898C26.0266 56.3906 27.4054 57.7694 29.1062 57.7694H31.0288C31.0715 57.764 31.115 57.7612 31.1592 57.7612C31.2034 57.7612 31.2469 57.764 31.2897 57.7694ZM65.0348 35.1857V32.1061C65.0348 30.4053 63.656 29.0265 61.9552 29.0265H29.1062C27.4054 29.0265 26.0266 30.4053 26.0266 32.1061V35.1857H65.0348ZM29.6194 32.1061C29.6194 31.2557 30.3088 30.5663 31.1592 30.5663C32.0097 30.5663 32.699 31.2557 32.699 32.1061C32.699 32.9565 32.0097 33.6459 31.1592 33.6459C30.3088 33.6459 29.6194 32.9565 29.6194 32.1061ZM35.2654 30.5663C34.415 30.5663 33.7256 31.2557 33.7256 32.1061C33.7256 32.9565 34.415 33.6459 35.2654 33.6459C36.1158 33.6459 36.8052 32.9565 36.8052 32.1061C36.8052 31.2557 36.1158 30.5663 35.2654 30.5663ZM37.8317 32.1061C37.8317 31.2557 38.5211 30.5663 39.3715 30.5663C40.2219 30.5663 40.9113 31.2557 40.9113 32.1061C40.9113 32.9565 40.2219 33.6459 39.3715 33.6459C38.5211 33.6459 37.8317 32.9565 37.8317 32.1061Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M66 48V58H35V61C35 62.1046 35.8954 63 37 63H67C68.1046 63 69 62.1046 69 61V48H66Z"
      fill="currentColor"
    />
    <path d="M29 40H62V53C62 54.1046 61.1046 55 60 55H31C29.8954 55 29 54.1046 29 53V40Z" fill="currentColor" />
  </svg>
  <svg *ngIf="type === 'genesys-web-messenger'" focusable="false" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
    ></path>
  </svg>
</aside>
